var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Clock",
    enableBackground: "new 0 0 139 139",
    height: 139,
    viewBox: "0 0 139 139",
    width: 139,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m69.5 11.666c-31.941 0-57.834 25.893-57.834 57.834s25.893 57.834 57.834 57.834 57.834-25.893 57.834-57.834-25.893-57.834-57.834-57.834zm25.258 79.117c-.92 1.626-2.613 2.54-4.357 2.54-.834 0-1.68-.209-2.457-.648l-20.905-11.821c-.057-.032-.102-.077-.157-.111-.148-.092-.287-.193-.424-.3-.127-.098-.252-.195-.368-.304s-.22-.226-.325-.346c-.109-.123-.217-.246-.313-.379-.093-.13-.173-.268-.254-.406-.08-.137-.16-.272-.226-.416-.069-.149-.123-.305-.178-.463-.052-.149-.103-.297-.14-.45s-.06-.311-.083-.47c-.025-.173-.045-.344-.052-.52-.002-.064-.019-.125-.019-.189v-40.833c0-2.761 2.239-5 5-5 2.762 0 5 2.239 5 5v37.917l18.366 10.386c2.404 1.359 3.251 4.41 1.892 6.813z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.1084e2241840183a73b58bd678eb4236.svg";
export { ForwardRef as ReactComponent };